angular.module("buyOrder.components", [])
    .component("buyOrder", {
        templateUrl: "ng/components/monitorPratica/buyOrder/buyOrder.view.html",
        bindings: {
            listaOrdini: "<",
            filter: '=',
            startRequest: '&'
        },
        controllerAs: "buyOrderCtrl",
        controller: BuyOrderController
    });

function BuyOrderController(
    $scope,
    $rootScope,
    $typeDomainService
) {
    var self = this;

    self.$onInit = function () {
        self.mapPracticeStatus = [];
        getStatusList();
        self.propMap = $rootScope.propMap

    };

    var getStatusList = function () {
        $typeDomainService.getDomainSet('APP_ORDER', 'PRACTICE_STATUS')
            .then(function (response) {
                response.domainList.forEach(function (item) {
                    self.mapPracticeStatus[item.value] = item.name
                })
            })
    }

    self.updateOrderTable = function (ordColName, ordType) {
        self.filter.orderColumnName = ordColName;
        self.filter.orderType = ordType;
        self.startRequest();
    }

    self.updateOffsetAndSearch = function () {
        self.filter.offset = (self.filter.pageIndex - 1) * self.filter.limit;
        self.startRequest();
    }

    $scope.pageIndexIndietro = function (value) {
        if (value == 'init') {
            self.filter.pageIndex = 1;
        } else {
            if (self.filter.pageIndex > 1) {
                self.filter.pageIndex--;
            }
        }
        self.updateOffsetAndSearch();
    }

    $scope.pageIndexAvanti = function (value) {
        if (value == 'end') {
            //subito pagina finale
            self.filter.pageIndex = self.filter.totalPages;
        } else {
            //avanzo +1
            if (self.filter.pageIndex < self.filter.totalPages) {
                self.filter.pageIndex++;
            }
        }
        self.updateOffsetAndSearch();
    }
}